<template>
	<button @click="onClick" class="btn_schedule_add">
		<span class="ico_cafe ico_plus">스케줄 추가하기</span>
	</button>
</template>

<script>
	export default {
		props: ['calendarId'],
		methods: {
			onClick() {
				location.href = `/${CAFEAPP.GRPCODE}/${CAFEAPP.FLDID}/new/_schedule_edit?calendarId=${this.calendarId}`;
			},
		},
	}
</script>
